import { http, HttpResponse } from 'msw'

import { type BillApprovalChainApiModel } from '../api-models/BillApprovalChainApiModel'
import { BillApprovalChainApiModelStub } from '../api-models/stubs/BillApprovalChainApiModel.stub'

export const mockGetBillApprovalChainsSuccess = (
  chains: BillApprovalChainApiModel[] = [
    BillApprovalChainApiModelStub.build({ id: 4, name: 'Default' }),
    BillApprovalChainApiModelStub.build({ id: 5, name: 'Finance approvals' }),
  ],
  skipBillApproval = false
) => {
  return http.get(`/api/v2/ap/approval-chains/requestable/`, () => {
    return HttpResponse.json(
      {
        data: chains,
        metadata: { skip_bill_approval: skipBillApproval },
      },
      { status: 200 }
    )
  })
}
